import { render } from "./MyIcon.vue?vue&type=template&id=b99db7ac"
import script from "./MyIcon.vue?vue&type=script&lang=js"
export * from "./MyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__